var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox flex_center",on:{"click":_vm.checkboxChange}},[(_vm.checkboxStatus)?_c('img',{attrs:{"src":require("@/assets/images/common/opt_of.png"),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }